import { ref } from 'vue'

type ExplodeTransforms = {
  autoExplode: (factor: number) => void
  reset: () => void
  hasCustomTransforms: () => boolean
}

export function useExplodeControl(transforms: ExplodeTransforms, clearSelection: () => void) {
  const explodeFactor = ref(0)
  const explodeConfirmOpen = ref(false)
  const explodeConfirmed = ref(false)
  let pendingExplode = 0

  function applyExplode(factor: number) {
    clearSelection()
    explodeFactor.value = factor
    transforms.autoExplode(factor)
  }

  function onAutoExplode(factor: number) {
    if (factor > 0 && !explodeConfirmed.value && transforms.hasCustomTransforms()) {
      pendingExplode = factor
      explodeConfirmOpen.value = true
      return
    }
    if (factor > 0) explodeConfirmed.value = true
    applyExplode(factor)
  }

  // Each fresh drag re-checks: a new drag over hand-placed parts asks again.
  function onExplodeEnd() {
    explodeConfirmed.value = false
  }

  function confirmExplodeOverride() {
    explodeConfirmOpen.value = false
    explodeConfirmed.value = true
    applyExplode(pendingExplode)
  }

  function cancelExplodeOverride() {
    explodeConfirmOpen.value = false
    pendingExplode = 0
  }

  function onResetTransforms() {
    clearSelection()
    explodeFactor.value = 0
    explodeConfirmed.value = false
    transforms.reset()
  }

  function resetExplodeState() {
    explodeFactor.value = 0
    explodeConfirmed.value = false
  }

  return {
    explodeFactor,
    explodeConfirmOpen,
    onAutoExplode,
    onExplodeEnd,
    confirmExplodeOverride,
    cancelExplodeOverride,
    onResetTransforms,
    resetExplodeState,
  }
}
